<template>
  <div class="users-management">
    <div class="loader" v-if="!tableDataLoaded">
      <div>
        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      </div>
    </div>
    <headerComponent></headerComponent>
    <div class="container position-relative mb-3">
      <div class="row">
        <div class="col-lg-4 col-12">
          <sidebarComponent></sidebarComponent>
        </div>
        <div class="col-lg-8 col-12">
          <div class="row">
            <div class="col-12" style="padding-left:18px">
              <button class="buttons button-one mb-3" @click="addUser()">Add User</button>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Username</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody v-if="Object.keys(usersList).length && tableDataLoaded">
                <tr v-for="user,index in usersList" :key="index" @click="goTo(user.id)">
                  <td>{{user.login}}</td>
                  <td>{{user.email}}</td>
                  <!--<td><button class="btn btn-primary" @click="goTo(user.id)">View</button> <button class="btn btn-danger" @click="deleteUser(user.id)">Delete</button></td>-->
                </tr>
              </tbody>
              <tbody v-if="!tableDataLoaded && !Object.keys(usersList).length">
                <tr>
                  <td colspan="2">Loading...</td>
                </tr>
              </tbody>
              <tbody v-if="tableDataLoaded && !Object.keys(usersList).length">
                <tr>
                  <td colspan="2">No data</td>
                </tr>
              </tbody>
            </table>
          </div>
          
        </div>
      </div>
      

    </div>
    <footerComponent></footerComponent>
  </div>
</template>

<script>
import footerComponent from '../components/Footer.vue'
import headerComponent from '../components/Header.vue'
import sidebarComponent from '../components/Sidebar.vue'
import axios from 'axios'
import commonProps from '../common/common.js'
import '@/assets/scss/users-list.scss'
const common = new commonProps;
export default {
  name:'users-management',
  components: {
    headerComponent,
    sidebarComponent,
    footerComponent
  },
  data() {
    return {
      usersList:[],
      tableDataLoaded:false
    }
  },
  mounted() {
    this.getUsersList()
  },
  methods: {
    getUsersList() {
      axios .get(`${common.supervisorApi}users/get_users_list`)
            .then( result => {
              //console.log(result.data)
              if (result.data && !result.data.error) {
                this.usersList = result.data.data
                this.tableDataLoaded = true
              }
            })
    },
    addUser() {
      this.$router.push('/user-edit');
    },
    deleteUser(userID) {
      axios .get(`${common.supervisorApi}users/delete_user_by_id/${userID}`)
            .then(result => {
              if (result.data)
                this.getUsersList()
            })
    },
    goTo(userID) {
      this.$router.push(`/user-edit/${userID}`)
    }
  }
}
</script>

